/**
 * @generated SignedSource<<db33c429b58229a9a073a6fb0ddc34b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCampaign_AtlassianSearchPage$data = {
  readonly entity: {
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly endDate?: string | null;
    readonly lastUpdated?: string | null;
    readonly owners?: ReadonlyArray<{
      readonly thirdPartyUser: {
        readonly name: string | null;
      } | null;
    } | null> | null;
    readonly status?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCampaign_AtlassianSearchPage";
};
export type searchGraphCampaign_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCampaign_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCampaign_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCampaign_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "endDate"
            },
            {
              "kind": "ScalarField",
              "name": "lastUpdated"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "owners",
              "plural": true,
              "selections": (v4/*: any*/)
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": (v4/*: any*/)
            }
          ],
          "type": "ExternalCampaign"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "d9dc4823e19ba6981e09da96d704b382";

export default node;
